import { Component, Input, OnInit, ViewChild } from '@angular/core'
import {
  IProvider,
  IState,
  ProviderContactsODataService,
  ProviderStateODataService
} from '@exchange/domain/.'
import {
  ActionButtonsColumnRendererComponent,
  GridWrapperComponent,
  LookupFilterComponent,
  Option
} from 'common-components'
import { ColDef } from 'ag-grid-community'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-providers-edit-contacts',
  templateUrl: './providers-edit-contacts.component.html',
  standalone: false
})
export class ProvidersEditContactsComponent implements OnInit {
  @ViewChild('contacts', { static: true }) contacts: GridWrapperComponent

  @Input() model: IProvider = {} as IProvider

  providerId: number = null
  states: IState[] = []
  stateOptions: Option[] = []

  constructor(
    private route: ActivatedRoute,
    private providerContactsODataService: ProviderContactsODataService,
    private stateService: ProviderStateODataService
  ) {}

  initializeStates(): void {
    this.stateService
      .query()
      .orderBy('Name')
      .exec()
      .subscribe(response => {
        this.states = response.data
        this.stateOptions = this.states.map(
          x => new Option(x.Id, `${x.Abbreviation} - (${x.Name})`, x)
        )

        this.contacts.setLookupFilterOptions('PhysicalAddress.StateId', this.stateOptions)

        return response
      })
  }

  initializeGrid(providerId): void {
    const columnDefs: ColDef[] = [
      {
        headerName: '',
        field: 'Actions',
        pinned: 'left',
        width: 100,
        cellRenderer: ActionButtonsColumnRendererComponent
      },
      {
        headerName: 'Name',
        field: 'Name',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Address',
        field: 'PhysicalAddress.Address1',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'City',
        field: 'PhysicalAddress.CityName',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'State',
        field: 'PhysicalAddress.StateId',
        width: 60,
        filter: 'lookupFilter',
        cellRenderer: GridWrapperComponent.LookupFieldRenderer(this.stateOptions)
      },
      {
        headerName: 'Zip Code',
        field: 'PhysicalAddress.ZipCode',
        width: 60,
        cellRenderer: GridWrapperComponent.ZipcodeRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      }
    ]
    const context = {
      canEdit: true,
      canDelete: true
    }

    this.contacts.gridOptions.context = context
    this.contacts.frameworkComponents = { lookupFilter: LookupFilterComponent }
    this.contacts.gridOptions.columnDefs = columnDefs
    this.contacts.filter = 'ProviderId eq ' + providerId
    this.contacts.odata = this.providerContactsODataService
  }

  ngOnInit() {
    this.providerId = +this.route.snapshot.params['id']
    this.initializeGrid(this.providerId)
    this.initializeStates()
  }
}
